import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

import Feather from 'react-native-vector-icons/Feather';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';

import FastImage from 'react-native-fast-image';

export const Container = styled.View`
  z-index: 2;

`;

export const HeaderTop = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const BackButton = styled.TouchableOpacity`
  padding: ${RFValue(4)}px;
  margin-left: -${RFValue(4)}px;
  margin-right: ${RFValue(8)}px;
`;

export const BackIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(22)}px;
`;

export const HeaderContent = styled.View`
  padding: 0 24px;

`;



export const LocalInfos = styled.View``;

export const Localization = styled.View``;

export const Profile = styled.View``;

export const SettingsIcon = styled(MaterialIcons)`
  font-size: ${RFValue(22)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const Avatar = styled(FastImage)`
  width: ${RFValue(38)}px;
  height: ${RFValue(38)}px;
  border-radius: ${RFValue(30)}px;
`;

export const Icon = styled(Feather)`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  margin-left: ${RFValue(5)}px;
`;

export const Local = styled.Text`
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(12)}px;

  font-family: ${({theme}) => theme.fonts.regular};
`;

export const RegionName = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const RegionInfo = styled.View`
  flex-direction: row;
`;

export const ProfileInfos = styled.TouchableOpacity`
  flex-direction: row;
  padding: ${RFValue(4)}px;
  margin-right: -${RFValue(4)}px;
  align-items: center;
`;

export const Row = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${RFValue(6)}px;
`;

export const HeaderButton = styled.View`
  align-items: center;
`;
export const HeaderIcon = styled(FontAwesome)`
  font-size: ${RFValue(22)}px;
  color: ${({theme}) => theme.colors.title};
`;
export const HeaderButtonLabel = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(8.5)}px;
`;



// Label para chip sólido (branco)
export const ChipLabelSolid = styled.Text`
  color: #fff;
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
`;

// Label para chip ghost (verde)
export const ChipLabelGhost = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
`;

export const ChipArrow = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.shape};
  margin-left: ${RFValue(4)}px;
`;




// Chip com ícone + label — variante sólida (fundo verde, texto branco)
export const ActionChipSolid = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: ${RFValue(36)}px;
  background-color: rgba(23, 183, 15, 1);
  padding-right: ${RFValue(10)}px;
`;

// Chip com ícone + label — variante ghost (fundo transparente, texto verde)
export const ActionChipGhost = styled(ActionChipSolid)`
  background-color: ${({theme}) => theme.colors.background};
`;

// Botão circular só com ícone (perfil)
export const ProfileButton = styled.TouchableOpacity`
  height: ${RFValue(32)}px;
  width: ${RFValue(32)}px;
  border-radius: ${RFValue(16)}px;
  background-color: ${({theme}) => theme.colors.profile_background};
  justify-content: center;
  align-items: center;
`;

export const ChipIconBox = styled.View`
  height: ${RFValue(28)}px;
  width: ${RFValue(28)}px;
  justify-content: center;
  align-items: center;
`;

export const ProfileInitials = styled.Text`
  color: ${({theme}) => theme.colors.profile_initials};
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(12)}px;
`;

// Ícone para chip sólido (branco)
export const ChipIconSolid = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(16)}px;
`;

// Ícone para chip ghost (verde)
export const ChipIconGhost = styled(FontAwesome5)`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(13)}px;
`;


